import React, { Component } from 'react';
import RecurveUtility from '../../../functions/utility';
import { ItemContext } from '../../../base_components/rootComponents/Item';
import ItemGroupSection from '../item/ItemGroupSection';
import IncludedModifierSection from '../item/IncludedModifierSection';
import ItemStyles from '../item/ItemStyles';
import AvailableModifierGroups from '../item/AvailableModifierGroups';
import AddOnItems from '../item/AddOnItems';
import ItemAddedPopup from '../item/ItemAddedPopup';
import Decorator from '../../../functions/decorator';
import { ItemCustomizationLayout } from '../../../ui/itemCustomization';

export default class StreamlinedItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            commentText: null,
            commentTextCount: 0,
            text_value: null,
            showMissingItemModal: false,
            showInvalidItemModal: false,
            error_title: ``,
            error_content: ``
        };
        this.utility = {...RecurveUtility};
        this.handleCommentBoxActions = this.handleCommentBoxActions.bind(this);
        this.toggleMissingItemModal = this.toggleMissingItemModal.bind(this);
        this.handleInvalidSubmitAttempt = this.handleInvalidSubmitAttempt.bind(this);
        this.toggleInvalidSelectionModal = this.toggleInvalidSelectionModal.bind(this);
    }

    handleCommentBoxActions(count) {
        this.setState({
            commentTextCount: count
        })
    }

    toggleMissingItemModal() {
        this.setState({
            showMissingItemModal: !this.state.showMissingItemModal
        })
    }

    toggleInvalidSelectionModal() {
        this.setState({
            showInvalidItemModal: !this.state.showInvalidItemModal
        })
    }

    async handleInvalidSubmitAttempt(itemContext, cartContext) {
        const submitAttempt = cartContext && typeof cartContext.submitItemAttempt === 'function'
            ? cartContext.submitItemAttempt.bind(cartContext)
            : async (context) => context.functions.processSubmitAttempt();

        const submitResult = await submitAttempt(itemContext);

        if (typeof submitResult === `undefined`) {
            return;
        }

        const [reason, main_item, bad_mod, reasons] = submitResult;

        if (reason === `invalid_selection`) {
            this.setState({
                error_title: `Oops, you can't choose that combination.`,
                error_content: `${Decorator.toProper(bad_mod.name)} is not available when selecting ${Decorator.toProper(main_item.name)}.`
            }, () => {
                this.toggleInvalidSelectionModal();
            });
        }

        if (reason === `selection_not_allowed`) {
            this.toggleMissingItemModal();
        }

        if (reason === `requirements_unmet`) {
            this.setState({
                error_title: `Oops, we still need to know a few more things.`,
                error_content: `${reasons}`
            }, () => {
                this.toggleInvalidSelectionModal();
            });
        }
    }

    render() {
        return (
            <ItemContext.Consumer>
                {
                    itemContext => {
                        const subtotal = itemContext.functions.calculateSubtotal();

                        return (
                            <div className='p-1'>
                                <ItemCustomizationLayout
                                    itemName={itemContext.name}
                                    itemImageUrl={itemContext.imageLarge || itemContext.imageSmall || null}
                                    itemDescription={itemContext.description ? itemContext.description : ''}
                                    quantity={itemContext.quantity}
                                    onQuantityDecrease={itemContext.functions.decreaseItemQuantity}
                                    onQuantityIncrease={itemContext.functions.increaseItemQuantity}
                                    requiredOptionsContent={(
                                        <div>
                                            <ItemGroupSection
                                                processSubmitAttempt={itemContext.functions.processSubmitAttempt}
                                                subtotal={subtotal}
                                                isValid={itemContext.isValid}
                                                selectMainItem={itemContext.functions.selectMainItem}
                                                choices={itemContext.choices}
                                                itemGroup={itemContext.itemGroup}
                                            />
                                            <ItemStyles
                                                allModifiers={itemContext.modifiers}
                                                setFirstHalf={itemContext.functions.setFirstHalfOnly}
                                                setSecondHalf={itemContext.functions.setSecondHalfOnly}
                                                setWhole={itemContext.functions.setWholePortion}
                                                itemGroup={itemContext.itemGroup}
                                                choices={itemContext.choices.modifiers}
                                                setExtra={itemContext.functions.setExtra}
                                                setLight={itemContext.functions.setLight}
                                                setNormal={itemContext.functions.setNormalSize}
                                                modifierGroups={itemContext.styles}
                                                removeModifier={itemContext.functions.removeOptionalModifier}
                                                handleModifierQuantityChange={itemContext.functions.handleItemQuantityChange}
                                                increaseModifierQuantity={itemContext.functions.increaseModifierQuantity}
                                                decreaseModifierQuantity={itemContext.functions.increaseModifierQuantity}
                                                markAsInvalid={itemContext.functions.markAsInvalid}
                                                markAsValid={itemContext.functions.markAsValid}
                                                isValid={itemContext.isValid}
                                                selectedMainItem={itemContext.choices.item}
                                            />
                                            {itemContext.maxToppings > -1 ? (
                                                <div className='container'>
                                                    <h3>{itemContext.functions.numberOfSelections()} / {itemContext.maxToppings} <small>(max selections)</small></h3>
                                                </div>
                                            ) : ''}
                                        </div>
                                    )}
                                    includedToppingsContent={(
                                        <IncludedModifierSection
                                            reAdd={itemContext.functions.reAddIncludedItem}
                                            exclude={itemContext.functions.excludeIncludedItem}
                                            excludedModifiers={itemContext.functions.determineExcludedModifiers()}
                                            allModifiers={itemContext.modifiers}
                                            chosenIncluded={itemContext.functions.determineIncludedModifiers()}
                                            setFirstHalf={itemContext.functions.setFirstHalfOnly}
                                            setSecondHalf={itemContext.functions.setSecondHalfOnly}
                                            setWhole={itemContext.functions.setWholePortion}
                                            choices={itemContext.choices.includedModifiers}
                                            setExtra={itemContext.functions.setExtra}
                                            setLight={itemContext.functions.setLight}
                                            setNormal={itemContext.functions.setNormalSize}
                                            selectedMainItem={itemContext.choices.item}
                                            itemGroup={itemContext.itemGroup}
                                        />
                                    )}
                                    modifierGroupsContent={(
                                        <div>
                                            <AvailableModifierGroups
                                                allModifiers={itemContext.modifiers}
                                                setFirstHalf={itemContext.functions.setFirstHalfOnly}
                                                setSecondHalf={itemContext.functions.setSecondHalfOnly}
                                                setWhole={itemContext.functions.setWholePortion}
                                                choices={itemContext.choices.modifiers}
                                                setExtra={itemContext.functions.setExtra}
                                                setLight={itemContext.functions.setLight}
                                                setNormal={itemContext.functions.setNormalSize}
                                                modifierGroups={itemContext.options}
                                                removeModifier={itemContext.functions.removeOptionalModifier}
                                                handleModifierQuantityChange={itemContext.functions.handleModifierQuantityChange}
                                                increaseModifierQuantity={itemContext.functions.increaseModifierQuantity}
                                                decreaseModifierQuantity={itemContext.functions.decreaseModifierQuantity}
                                                selectedMainItem={itemContext.choices.item}
                                                itemGroup={itemContext.itemGroup}
                                                chosenIncluded={itemContext.functions.determineIncludedModifiers()}
                                            />

                                            <AddOnItems
                                                addonGroups={itemContext.addonGroups}
                                                chooseAddOnItem={itemContext.functions.chooseAddOnItem}
                                                removeItem={itemContext.functions.removeAddOnItem}
                                                increaseAddOnQuantity={itemContext.functions.increaseAddOnQuantity}
                                                decreaseAddOnQuantity={itemContext.functions.decreaseAddOnQuantity}
                                                addOnChoices={itemContext.choices.addOns}
                                                selectedMainItem={itemContext.choices.item}
                                            />

                                            {itemContext.itemAdded ? <ItemAddedPopup itemBaseName={itemContext.name} /> : ''}
                                        </div>
                                    )}
                                    addToCartLabel={window.editLineID ? 'FINISHED EDITING ITEM' : 'ADD TO CART NOW'}
                                    addToCartAmount={isNaN(subtotal) ? 0 : subtotal}
                                    isAddToCartDisabled={isNaN(subtotal)}
                                    onAddToCart={() => {
                                        if (!isNaN(subtotal)) {
                                            this.handleInvalidSubmitAttempt(itemContext);
                                        }
                                    }}
                                />
                            </div>
                        );
                    }
                }
            </ItemContext.Consumer>
        )
    }
}
